import { apiRequest } from './client'

export type AuthNextStep = 'NEW_PASSWORD' | 'MFA_SETUP' | 'MFA_CODE' | 'DONE'

export type CurrentUser = {
  name: string
  email: string
  partner: { key: string; name: string }
}

export type MfaSetup = {
  qrCodeDataUrl: string
  secretCode: string
}

const step = (next: { next: AuthNextStep }) => next.next

export const authApi = {
  async login(email: string, password: string): Promise<AuthNextStep> {
    return step(await apiRequest('/api/auth/login', { method: 'POST', body: { email, password } }))
  },

  async setNewPassword(newPassword: string): Promise<AuthNextStep> {
    return step(await apiRequest('/api/auth/new-password', { method: 'POST', body: { newPassword } }))
  },

  async startMfaSetup(): Promise<MfaSetup> {
    return apiRequest('/api/auth/mfa/setup', { method: 'POST', body: {} })
  },

  async verifyMfaSetup(code: string): Promise<AuthNextStep> {
    return step(await apiRequest('/api/auth/mfa/verify', { method: 'POST', body: { code } }))
  },

  async answerMfaCode(code: string): Promise<AuthNextStep> {
    return step(await apiRequest('/api/auth/mfa/code', { method: 'POST', body: { code } }))
  },

  async logout(): Promise<void> {
    await apiRequest('/api/auth/logout', { method: 'POST' })
  },

  async me(): Promise<CurrentUser> {
    return apiRequest('/api/auth/me')
  },
}
